export default [
          {
          value: 'Colombo',
          label: 'Colombo',
         
            children: [{
              value: 'Colombo 01',
              label: 'Colombo 01'
            },{
              value: 'Colombo 02',
              label: 'Colombo 02'
            },{
              value: 'Colombo 03',
              label: 'Colombo 03'
            },{
              value: 'Colombo 04',
              label: 'Colombo 04'
            },{
              value: 'Colombo 05',
              label: 'Colombo 05'
            },{
              value: 'Colombo 06',
              label: 'Colombo 06'
            },{
              value: 'Colombo 07',
              label: 'Colombo 07'
            },{
              value: 'Colombo 08',
              label: 'Colombo 08'
            },{
              value: 'Colombo 08',
              label: 'Colombo 08'
            },{
              value: 'Colombo 08',
              label: 'Colombo 08'
            },{
              value: 'Colombo 09',
              label: 'Colombo 09'
            },{
              value: 'Colombo 10',
              label: 'Colombo 10'
            },{
              value: 'Colombo 11',
              label: 'Colombo 11'
            },{
              value: 'Colombo 12',
              label: 'Colombo 12'
            },{
              value: 'Colombo 13',
              label: 'Colombo 13'
            },{
              value: 'Colombo 14',
              label: 'Colombo 14'
            },{
              value: 'Colombo 15',
              label: 'Colombo 15'
            }, {
              value: 'Angoda ',
              label: 'Angoda '
            }, {
              value: 'Athurugiriya',
              label: 'Athurugiriya'
            }, {
              value: 'Awissawella',
              label: 'Awissawella'
            }, {
              value: 'Battaramulla',
              label: 'Battaramulla'
            }, {
              value: 'Boralesgamuwa',	
              label: 'Boralesgamuwa'
            }, {
              value: 'Hanwella',
              label: 'Hanwella'
            }, {
              value: 'Homagama ',
              label: 'Homagama '
            }, {
              value: 'Kaduwela',
              label: 'Kaduwela'
            }, {
              value: 'Kesbewa',
              label: 'Kesbewa'
            }, {
              value: 'Kohuwala',
              label: 'Kohuwala'
            }, {
              value: 'Kolonnawa',
              label: 'Kolonnawa'
            }, {
              value: 'Kottawa',
              label: 'Kottawa'
            }, {
              value: 'Kotte',
              label: 'Kotte'
            }, {
              value: 'Malabe',
              label: 'Malabe'
            }, {
              value: 'Moratuwa',
              label: 'Moratuwa'
            }, {
              value: 'Mount Lavinia',
              label: 'Mount Lavinia'
            }, {
              value: 'Nawala',
              label: 'Nawala'
            },   {
              value: 'Padukka',
              label: 'Padukka'
            },   {
              value: 'Pannipitiya',
              label: 'Pannipitiya'
            },   {
              value: 'Rathmalana',
              label: 'Rathmalana'
            },   {
              value: 'Thalawathugoda',
              label: 'Thalawathugoda'
            },   {
              value: 'Wellampitiya',
              label: 'Wellampitiya'
            },   {
              value: 'Nugegoda',
              label: 'Nugegoda'
            },   {
              value: 'Dehiwala',
              label: 'Dehiwala'
            },   {
              value: 'Piliyandala',
              label: 'Piliyandala'
            },   {
              value: 'Rajagiriya',
              label: 'Rajagiriya'
            },   {
              value: 'Maharagama',
              label: 'Maharagama'
            
          }]
        },

        {
          value: 'Kandy',
          label: 'Kandy',
         
            children: [{
              value: 'Kandy',
              label: 'Kandy'
            }, {
              value: 'Katugastota',
              label: 'Katugastota'
            }, {
              value: 'Peradeniya',
              label: 'Peradeniya'
            }, {
              value: 'Gampola',
              label: 'Gampola'
            },  {
              value: 'Kadugannawa',
              label: 'Kadugannawa'
            },  {
              value: 'Kundasale',
              label: 'Kundasale'
            },  {
              value: 'Akurana',
              label: 'Akurana'
            },{
              value: 'Gelioya',
              label: 'Gelioya'
            },{
              value: 'Nawalapitiya',
              label: 'Nawalapitiya'
            },{
              value: 'Pilimathalawa',
              label: 'Pilimathalawa'
            
          }]
        },

         {
          value: 'Kurunegala',
          label: 'Kurunegala',
         
            children: [{
              value: 'Kurunegala',
              label: 'Kurunegala'
            }, {
              value: 'Kuliyapitiya',
              label: 'Kuliyapitiya'
            }, {
              value: 'Pannala',
              label: 'Pannala'
            }, {
              value: 'Narammala',
              label: 'Narammala'
            }, {
              value: 'Wariyapola',
              label: 'Wariyapola'
            }, {
              value: 'Alawwa',
              label: 'Alawwa'
            }, {
              value: 'Bingiriya',
              label: 'Bingiriya'
            }, {
              value: 'Galgamuwa',
              label: 'Galgamuwa'
            }, {
              value: 'Giriulla',
              label: 'Giriulla'
            }, {
              value: 'Hettipola',
              label: 'Hettipola'
            }, {
              value: 'Ibbagamuwa',
              label: 'Ibbagamuwa'
            }, {
              value: 'Mawathagama',
              label: 'Mawathagama'
            }, {
              value: 'Nikaweratiya',
              label: 'Nikaweratiya'
            }, {
              value: 'Polgahawela',
              label: 'Polgahawela'
             
          }]
        },

        {
          value: 'Ratnapura',
          label: 'Ratnapura',
         
            children: [{
              value: 'Ratnapura',
              label: 'Ratnapura'
            }, {
              value: 'Embilipitiya',
              label: 'Embilipitiya'
            }, {
              value: 'Balangoda',
              label: 'Balangoda'
            }, {
              value: 'Pelmadulla',
              label: 'Pelmadulla'
            }, {
              value: 'Eheliyagoda',
              label: 'Eheliyagoda'
            }, {
              value: 'Kuruwita',
              label: 'Kuruwita'
            }, {
              value: 'Godakawela',
              label: 'Godakawela'
            }, {
              value: 'Udawalawa',
              label: 'Udawalawa'
            
            
          }]
        },

         {
          value: 'Galle',
          label: 'Galle',
         
            children: [{
              value: 'Galle',
              label: 'Galle'
            }, {
              value: 'Ambalangoda',
              label: 'Ambalangoda'
            }, {
              value: 'Elpitiya',
              label: 'Elpitiya'
            }, {
              value: 'Hikkaduwa',
              label: 'Hikkaduwa'
            }, {
              value: 'Baddegama',
              label: 'Baddegama'
            }, {
              value: 'Ahangama',
              label: 'Ahangama'
            }, {
              value: 'Batapola',
              label: 'Batapola'
            }, {
              value: 'Benthota',
              label: 'Benthota'
            }, {
              value: 'Katapitiya',
              label: 'Katapitiya'
                     
          }]
        },

        {
          value: 'Ampara',
          label: 'Ampara',
         
            children: [{
              value: 'Ampara',
              label: 'Ampara'
            }, {
              value: 'Akkarepattu',
              label: 'Akkarepattu'
            }, {
              value: 'Kalmunai',
              label: 'Kalmunai'
            }, {
              value: 'Sainthamaruthu',
              label: 'Sainthamaruthu'
            
          }]
        },

         {
          value: 'Anuradhapura',
          label: 'Anuradhapura',
         
            children: [{
              value: 'Anuradhapura',
              label: 'Anuradhapura'
            }, {
              value: 'Kekirawa',
              label: 'Kekirawa'
            }, {
              value: 'Medawachchiya',
              label: 'Medawachchiya'
            }, {
              value: 'Eppawala',
              label: 'Eppawala'
            },  {
              value: 'Tambuttegama',
              label: 'Tambuttegama'
            },{
              value: 'Galenbidunuwewa',
              label: 'Galenbidunuwewa'
            },{
              value: 'Galnewa',
              label: 'Galnewa'
            },{
              value: 'Habarana',
              label: 'Habarana'
            },{
              value: 'Mihinthale',
              label: 'Mihinthale'
            },{
              value: 'Nochchiyagama',
              label: 'Nochchiyagama'
            },{
              value: 'Thalawa',
              label: 'Thalawa'
                       
          }]
        },

         
         {
          value: 'Badulla',
          label: 'Badulla',
         
            children: [{
              value: 'Badulla',
              label: 'Badulla'
            }, {
              value: 'Bandarawela',
              label: 'Bandarawela'
            }, {
              value: 'Welimada',
              label: 'Welimada'
            }, {
              value: 'Mahiyanganaya',
              label: 'Mahiyanganaya'
            }, {
              value: 'Ella',
              label: 'Ella'
            },{
              value: 'Haputale',
              label: 'Haputale'
           
          }]
        },

        {
          value: 'Batticaloa',
          label: 'Batticaloa',
         
            children: [{
              value: 'Batticaloa',
              label: 'Batticaloa'
          
          }]
        },

        {
          value: 'Gampaha',
          label: 'Gampaha',
         
            children: [{
              value: 'Gampaha',
              label: 'Gampaha'
            },  {
              value: 'Negombo',
              label: 'Negombo'
            },  {
              value: 'Kelaniya',
              label: 'Kelaniya'
            },  {
              value: 'Kiribathgoda',
              label: 'Kiribathgoda'
            },  {
              value: 'Kadawatha',
              label: 'Kadawatha'
            },  {
              value: 'Delgoda',
              label: 'Delgoda'
            },  {
              value: 'Divulapitiya',
              label: 'Divulapitiya'
            },  {
              value: 'Ganemulla',
              label: 'Ganemulla'
            },  {
              value: 'Ja-Ela',
              label: 'Ja-Ela'
            },  {
              value: 'Kandana',
              label: 'Kandana'
            },  {
              value: 'Katunayake',
              label: 'Katunayake'
            },  {
              value: 'Minuwangoda',
              label: 'Minuwangoda'
            },  {
              value: 'Mirigama',
              label: 'Mirigama'
            },  {
              value: 'Nittambuwa',
              label: 'Nittambuwa'
            },  {
              value: 'Ragama',
              label: 'Ragama'
            },  {
              value: 'Veyangoda',
              label: 'Veyangoda'
            },  {
              value: 'Wattala',
              label: 'Wattala'

          }]
        },

        {
          value: 'Hambantota',
          label: 'Hambantota',
         
            children: [{
              value: 'Hambantota',
              label: 'Hambantota'
            }, {
              value: 'Tangalla',
              label: 'Tangalla'
            }, {
              value: 'Beliatta',
              label: 'Beliatta'
            }, {
              value: 'Ambalantota',
              label: 'Ambalantota'
            }, {
              value: 'Tissamaharama',
              label: 'Tissamaharama'
                        
          }]
        },

         {
          value: 'Jaffna',
          label: 'Jaffna',
         
            children: [{
              value: 'Jaffna',
              label: 'Jaffna'
            }, {
              value: 'Nallur',
              label: 'Nallur'
            }, {
              value: 'Chavakachcheri',
              label: 'Chavakachcheri'
          
            
          }]
        },

        {
          value: 'Kalutara',
          label: 'Kalutara',
         
            children: [{
              value: 'Kalutara',
              label: 'Kalutara'
            }, {
              value: 'Horana',
              label: 'Horana'
            }, {
              value: 'Panadura',
              label: 'Panadura'
            }, {
              value: 'Bandaragama',
              label: 'Bandaragama'
            }, {           		
              value: 'Dharga Town',
              label: 'Dharga Town'
            }, {           		
              value: 'Matugama',
              label: 'Matugama'
            }, {
              value: 'Aluthgama',
              label: 'Aluthgama'
            }, {
              value: 'Beruwala',
              label: 'Beruwala'
            }, {
              value: 'Ingiriya',
              label: 'Ingiriya'
            }, {
              value: 'Wadduwa',
              label: 'Wadduwa'
            
          }]
        },

        {
          value: 'Kegalle',
          label: 'Kegalle',
         
            children: [{
              value: 'Kegalle',
              label: 'Kegalle'
            }, {
              value: 'Aranayaka',
              label: 'Aranayaka'
            }, {
              value: 'Mawanella',
              label: 'Mawanella'
            }, {
              value: 'Warakapola',
              label: 'Warakapola'
            }, {
              value: 'Rambukkana',
              label: 'Rambukkana'
            }, {
              value: 'Galigamuwa',
              label: 'Galigamuwa'
                        
          }]
        },

        {
          value: 'Kilinochchi',
          label: 'Kilinochchi',
         
            children: [{
              value: 'All of Kilinochchi',
              label: 'All of Kilinochchi'
            },{
              value: 'Kilinochchi',
              label: 'Kilinochchi'
          },]
        },


        {
          value: 'Mannar',
          label: 'Mannar',
         
            children: [{
              value: 'Mannar',
              label: 'Mannar'
            
          }]
        },

        {
          value: 'Matale',
          label: 'Matale',
         
            children: [{
              value: 'Matale',
              label: 'Matale'
            }, {
              value: 'Dambulla',
              label: 'Dambulla'
            }, {
              value: 'Galewela',
              label: 'Galewela'
            }, {
              value: 'Ukuwela',
              label: 'Ukuwela'
            },  {
              value: 'Sigiriya',
              label: 'Sigiriya'
            },{
              value: 'Palapathwela',
              label: 'Palapathwela'
            },{
              value: 'Rattota',
              label: 'Rattota'
            },{
              value: 'Yatawatta',
              label: 'Yatawatta'
           
          }]
        },

        {
          value: 'Matara',
          label: 'Matara',
         
            children: [{
              value: 'Matara',
              label: 'Matara'
            }, {
              value: 'Akuressa',
              label: 'Akuressa'
            }, {
              value: 'Weligama',
              label: 'Weligama'
            }, {
              value: 'Dikwella',
              label: 'Dikwella'
            }, {
              value: 'Hakmana',
              label: 'Hakmana'
            },{
              value: 'Deniyaya',
              label: 'Deniyaya'
            },{
              value: 'Kamburugamuwa',
              label: 'Kamburugamuwa'
            },{
              value: 'Kamburupitiya',
              label: 'Kamburupitiya'
            },{
              value: 'Mirissa',
              label: 'Mirissa'
            },{
              value: 'Morawaka',
              label: 'Morawaka'
            },{
              value: 'Pitabaddara',
              label: 'Pitabaddara'
            
           
          }]
        },

         {
          value: 'Monaragala',
          label: 'Monaragala',
         
            children: [{
              value: 'Monaragala',
              label: 'Monaragala'
            }, {
              value: 'Wellawaya',
              label: 'Wellawaya'
            }, {
              value: 'Bibile',
              label: 'Bibile'
            }, {
              value: 'Kataragama',
              label: 'Kataragama'
            }, {
              value: 'Buttala',
              label: 'Buttala'
                        
          }]
        },

        {
          value: 'Mullativu',
          label: 'Mullativu',
         
            children: [{
              value: 'Mullativu',
              label: 'Mullativu'
        
          }]
        },

        {
          value: 'Nuwara Eliya',
          label: 'Nuwara Eliya',
         
            children: [{
              value: 'Nuwara Eliya',
              label: 'Nuwara Eliya'
            }, {
              value: 'Hatton',
              label: 'Hatton'
            }, {
              value: 'Ginigathena',
              label: 'Ginigathena'
            }, {
              value: 'Thalawakele',
              label: 'Thalawakele'
            },  {
              value: 'Maskeliya',
              label: 'Maskeliya'
                       
          }]
        },

        {
          value: 'Polonnaruwa',
          label: 'Polonnaruwa',
         
            children: [{
              value: 'Polonnaruwa',
              label: 'Polonnaruwa'
            }, {
              value: 'Kaduruwela',
              label: 'Kaduruwela'
            }, {
              value: 'Hingurakgoda',
              label: 'Hingurakgoda'
            }, {
              value: 'Medirigiriya',
              label: 'Medirigiriya'

          }]
        },


         {
          value: 'Puttalam',
          label: 'Puttalam',
         
            children: [{
              value: 'Puttalam',
              label: 'Puttalam'
            }, {
              value: 'Chilaw',
              label: 'Chilaw'
            }, {
              value: 'Wennappuwa',
              label: 'Wennappuwa'
            }, {
              value: 'Dankotuwa',
              label: 'Dankotuwa'
            },  {
              value: 'Nattandiya',
              label: 'Nattandiya'
            },{
              value: 'Marawila',
              label: 'Marawila'
           
          }]
        },

         {
          value: 'Trincomalee',
          label: 'Trincomalee',
         
            children: [{
              value: 'Trincomalee',
              label: 'Trincomalee'
            }, {
              value: 'Kinniya',
              label: 'Kinniya'
                       
          }]
        },

         {
          value: 'Vavuniya',
          label: 'Vavuniya',
         
            children: [{
              value: 'Vavuniya',
              label: 'Vavuniya'
           
          }]
        },

        
]


// WEBPACK FOOTER //
// ./src/data/regcities.js